class pdpHangerTool {
    constructor(element) {
        this.element = element;
        this.container = {
            manufacturerEl: this.element.querySelector('[data-manufacturer-select]'),
            dropdowns: this.element.querySelectorAll('[data-cascading-dropdown]')
        };

        this.initializeFinder();
        this.bindEvents('onload');

        this.element.querySelectorAll("[data-custom-dropdown-input]").forEach(input => {
        input.addEventListener("input", (e) => {
            const dropdown = e.target.closest("custom-select");
            if (dropdown) {
            const filter = e.target.value.toLowerCase();
            const options = dropdown.querySelectorAll("ul li");

            options.forEach(option => {
                const dataValue = option.getAttribute("data-value")?.toLowerCase() || "";
                if (dataValue.includes(filter)) {
                option.classList.remove("d-none");
                } else {
                option.classList.add("d-none");
                }
            });
            }
        });
        });
    }

    bindEvents(evt) {
        this.container.dropdowns.forEach(container => {
            if(evt == 'func' && container.getAttribute('data-step') == '1')
            return;
    
            container.querySelectorAll('ul li').forEach(option => {
                option.querySelector('input').addEventListener('change', (e) => this.selectAndCascade(container, e.target));
            });
        });

        document.body.addEventListener('click', (e) => {
            if(document.querySelector('.pdp-filter-container').querySelectorAll('.custom-select.open').length > 1) this.closeDropdown();
        });
    }

    closeDropdown() { 
        document.querySelectorAll('custom-select').forEach((x)=> {
        Utility.toggleElement(x, 'close');
        x.classList.remove('open');
        x.querySelector('button').setAttribute('aria-expanded', 'false');
        Utility.removeTrapFocus(x.querySelector('button'));
        })
    }

    async selectAndCascade(container, selectedOption) {
        
        const valueDisplay = container.querySelector('custom-select');
        const optionsList = container.querySelector('ul');
        const selectedValue = selectedOption.value;

        // // --- 1. UPDATE CURRENT DROPDOWN'S DISPLAY ---
        valueDisplay.querySelector('.option_txt').textContent = selectedValue;
        valueDisplay.querySelector(".custom-dropdown-input").value = selectedValue;
        valueDisplay.classList.add("selected-value");
        // valueDisplay.dataset.value = selectedValue;

        optionsList.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        
        if (selectedValue) 
        selectedOption.closest('li').classList.add('selected');

        container.querySelector('custom-select').classList.remove('open'); // Close the dropdown
        container.querySelector('.toggle-content').classList.remove('open');
        container.querySelector('button').setAttribute('aria-expanded', 'false');
        

        // --- 2. FIND CURRENT POSITION AND CLEAR SUBSEQUENT DROPDOWNS ---
        const currentIndex = Array.from(this.container.dropdowns).indexOf(container);

        if(currentIndex == 0){           
            document.querySelector('[data-error-msg]').classList.add('d-none');
            document.querySelector('[data-success-msg]').classList.add('d-none');
        }

        for (let i = currentIndex + 1; i < this.container.dropdowns.length; i++) {
            const nextContainer = this.container.dropdowns[i];
            nextContainer.classList.add('opacity-60', 'pointer-events-none');
            
            const nextValueDisplay = nextContainer.querySelector('custom-select');
            const nextOptionsList = nextContainer.querySelector('[data-manufacturer-lists]');
            nextValueDisplay.querySelector('.option_txt').textContent = nextValueDisplay.getAttribute('data-label-text');
            // nextOptionsList.innerHTML = '';
        }

        // // --- 3. IF SELECTION IS VALID, POPULATE AND TRIGGER NEXT ---
        if (selectedValue) {
        
            const params = {};
            let currentKey = '';
            
            for (let i = 0; i <= currentIndex; i++) {          
                const currentContainer = this.container.dropdowns[i];
                const key = currentContainer.querySelector('[data-param-name]').dataset.paramName;
                currentKey = key;

                let value = currentContainer.querySelector('ul li.selected input').value;
                if (key && value) {
                    if(key == 'trim' && value == 'No Trim'){
                        params[key] = null;
                    } else if(key == 'year' && value == 'All Years'){
                        params[key] = null;
                    } else {
                        params[key] = value;
                    }
                }
            }
            
            let options = [];
            const nextContainer = this.container.dropdowns[currentIndex + 1];

            if (nextContainer) {
                const optionsValue = await this.fetchSearchData(params);
                const nextOptionsList = nextContainer.querySelector('ul');

                nextContainer.querySelector('.option_txt').textContent = '-- Loading... --';
                // nextContainer.querySelector(".custom-dropdown-input").value = '-- Loading... --';

                if(nextContainer.getAttribute('data-step') == '2') {
                    options = optionsValue.data.models;
                } else if(nextContainer.getAttribute('data-step') == '3') {
                    options = optionsValue.data.trims;
                } else if(nextContainer.getAttribute('data-step') == '4') {
                    options = optionsValue.data.years;
                }

                nextContainer.querySelector('.option_txt').textContent = nextContainer.querySelector('[data-label-text]').getAttribute('data-label-text');       
                nextContainer.querySelector(".custom-dropdown-input").value = ''; 
                nextContainer.querySelector(".custom-dropdown").classList.remove("selected-value");
                nextOptionsList.innerHTML = ''; 
                
                if (options.length > 0) {
                    const html = this.createOptionHTML(options, nextContainer.querySelector('[data-param-name]').dataset.paramName);     
                    nextOptionsList.innerHTML = html;
                    nextContainer.classList.remove('opacity-60', 'pointer-events-none');
                    this.bindEvents('func');
                } else {
                    nextContainer.classList.remove('opacity-60', 'pointer-events-none');
                }
            } else {
                const optionsValue = await this.fetchSearchData(params);
                this.updateProductRecommendations(optionsValue.data.products); 
            }
        }
    }

    async fetchSearchData(params = {}) {
        const url = new URL('/apps/proxy/hangers/search', window.location.origin);
        Object.entries(params).forEach(([key, value]) => {
        if (value) url.searchParams.append(key, value);
        });

        const response = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return response.json();
    }

    async initializeFinder() {
        try {
            const data = await this.fetchSearchData();
            this.renderManufacturer(data.data.manufacturers);
        } catch (error) {
            console.error('Error initializing Hanger Finder:', error);
        }
    }

    createOptionHTML(items, namePrefix) {
        // return items.filter(item => item != null).map(item => {
        return items.map(item => {
        if((namePrefix == 'trim' || namePrefix == 'year') && item == null){
            return `<li data-value="${item}" class="form-check align-items-center d-flex" role="menuitem" tabindex="0">
                <input type="radio" value="${namePrefix == 'trim' ? 'No Trim' : 'All Years'}" class="${namePrefix}_options form-check-input" 
                    name="${namePrefix}" id="${namePrefix}-all" tabindex="-1" data-${namePrefix}-opt>
                <label for="${namePrefix}-all" class="option_txt form-check-label w-100" title="${item}">${namePrefix == 'trim' ? 'No Trim' : 'All Years'}</label>
                <svg class="ms-auto" xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                <use href="#icon-check"></use>
                </svg>
            </li>`;
        } else {
            const sanitizedId = item.toString().replace(/\s+/g, "-");
            return `
            <li data-value="${item}" class="form-check align-items-center d-flex" role="menuitem" tabindex="0">
                <input type="radio" value="${item}" class="${namePrefix}_options form-check-input" 
                    name="${namePrefix}" id="${namePrefix}-${sanitizedId}" tabindex="-1" data-${namePrefix}-opt>
                <label for="${namePrefix}-${sanitizedId}" class="option_txt form-check-label w-100" title="${item}">${item}</label>
                <svg class="ms-auto" xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                <use href="#icon-check"></use>
                </svg>
            </li>`;
        }
        }).join('');
    }

    renderManufacturer(data) {
        const html = this.createOptionHTML(data, 'manufacturer');
        this.container.manufacturerEl.querySelector('[data-manufacturer-lists]').innerHTML = html;
        const cascadingDropdown = this.container.manufacturerEl.closest('[data-cascading-dropdown]');
        cascadingDropdown.querySelector('.option_txt').textContent = 
        cascadingDropdown.querySelector('[data-label-text]').getAttribute('data-label-text');
        
        this.bindEvents('onload');
    }

    updateProductRecommendations(products) {
        if(products.length > 0){
            const matched = products.map(variant => variant.variantId == window.globalSpace.currentVariant.id);
            
            if(matched.includes(true)){
                document.querySelector('[data-error-msg]').classList.add('d-none');
                document.querySelector('[data-success-msg]').classList.remove('d-none');
            } else {
                document.querySelector('[data-error-msg]').classList.remove('d-none');
                document.querySelector('[data-success-msg]').classList.add('d-none');
            }
        } else {            
            document.querySelector('[data-error-msg]').classList.remove('d-none');
            document.querySelector('[data-success-msg]').classList.add('d-none');
        }

    }

    static init() {
        const collapsibleElements = document.querySelector('[data-finder-content]');
        new pdpHangerTool(collapsibleElements);
    }
}
pdpHangerTool.init();

